
import { BusinessHours } from '../../../../mocks/directoryDetails';

interface HoursCardProps {
  hours: BusinessHours[];
}

export default function HoursCard({ hours }: HoursCardProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
      <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-time-line text-teal-600"></i>
        </div>
        Business Hours
      </h3>
      <div className="space-y-2.5">
        {hours.map((h) => (
          <div
            key={h.day}
            className={`flex items-center justify-between text-sm px-3 py-2 rounded-lg ${
              h.isToday ? 'bg-teal-50 border border-teal-100' : ''
            }`}
          >
            <span className={`font-medium ${h.isToday ? 'text-teal-700' : 'text-gray-700'}`}>
              {h.day}
              {h.isToday && (
                <span className="ml-2 text-[10px] font-bold text-teal-600 bg-teal-100 px-1.5 py-0.5 rounded-full uppercase">
                  Today
                </span>
              )}
            </span>
            <span
              className={`${
                h.isToday ? 'text-teal-700 font-semibold' : 'text-gray-600'
              } ${h.hours === 'Closed' ? 'text-red-500' : ''}`}
            >
              {h.hours}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
